// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

export const isNullOrUndefined = (value: unknown): value is null | undefined => value == null;
